// This is a Configuration file exclusive to devices and device groups
// Should this be converted into a CONFIG file inside of a config folder?
// Features / Devices / Config / deviceGroupRules

//two types| Road Closures and Sirens
export const groupRules = {
  version: '1.0',
  ruleType: 'device_group_compatibility',
  // typeMap: normalized device_type strings used by connected devices.
  // Keep normalized values (lowercase, no slashes/whitespace, underscores allowed)
  typeMap: {
    controllers: ['stage', 'monitoringstation'],
    devices: [
      'manualroadclosure',
      'technologybridge_flashinglights',
      'technologybridge_sirengiantvoice',
    ],
    aux_devices: ['overwatchvms'],
  },

  controllers: {
    aware: {
      devices: {
        manualroadclosure: 'YES',
        technologybridge_flashinglights: 'YES',
        technologybridge_sirengiantvoice: 'YES',
      },
    },
    usgs: {
      devices: {
        manualroadclosure: 'YES',
        technologybridge_flashinglights: 'YES',
        technologybridge_sirengiantvoice: 'YES',
      },
    },
  },

  devices: {
    manualroadclosure: {
      standaloneAllowed: true,
    },
    technologybridge_flashinglights: {
      standaloneAllowed: true,
    },
    technologybridge_sirengiantvoice: {
      standaloneAllowed: true,
    },
  },

  aux_devices: {
    overwatchvms: {
      standaloneAllowed: true,
    },
  },

  deviceMixRules: {
    'manualroadclosure:manualroadclosure': 'YES',
    'manualroadclosure:technologybridge_sirengiantvoice': 'NO',
    'manualroadclosure:technologybridge_flashinglights': 'YES',
    'technologybridge_flashinglights:technologybridge_sirengiantvoice': 'NO',
    'technologybridge_flashinglights:technologybridge_flashinglights': 'YES',
    'technologybridge_flashinglights:manualroadclosure': 'YES',
    'technologybridge_sirengiantvoice:manualroadclosure': 'NO',
    'technologybridge_sirengiantvoice:technologybridge_flashinglights': 'NO',
    'technologybridge_sirengiantvoice:technologybridge_sirengiantvoice': 'YES',
  },
};
